<!-- <mat-toolbar class="layout" [ngStyle]="{'background-color': toolbar?.color}"  -->
<mat-toolbar class="config" [ngClass]="{
  'config__white' : config === 'white',
  'config__black' : config === 'black'
  }" [ngStyle]="getDynamicStyles()"
>
  <!-- left icon button -->
<ng-container>
  <!-- <ng-template [ngIf]="toolbar?.sidenav == true">
    <button mat-icon-button><mat-icon (click)="drawerToggle()">menu</mat-icon></button>
  </ng-template> -->
  <ng-content select="[left]"></ng-content>
  <ng-template [ngIf]="toolbar?.btnBack == true">
    <button mat-icon-button><mat-icon (click)="back()">arrow_back</mat-icon></button>
  </ng-template>
  <ng-template [ngIf]="toolbar?.btnClose == true">
    <button mat-icon-button><mat-icon (click)="close()">close</mat-icon></button>
  </ng-template>
</ng-container>

<!-- LOGO -->
<ng-container>
  <ng-template [ngIf]="toolbar?.logo == true"><img class="logo" src="{{logoUrl}}"></ng-template>
  <ng-template class="title" [ngIf]="toolbar?.logo == false">{{toolbar?.title}}</ng-template>
</ng-container>

<span fxFlex></span>

<!-- MENU ICON WITH LABEL -->
<ng-container>
  <ng-template [ngIf]="config === 'white'">
    <div *ngIf="viewport?.name == 'xs'; else menu_label">
      <button mat-icon-button title="Menu" *ngIf="toolbar?.menu == true" [ngStyle]="{'color':'black'}" (click)="viewMenu()"><mat-icon>local_dining</mat-icon></button>
    </div>
    <ng-template #menu_label>
      <button mat-button class="button-rounded" title="Menu" *ngIf="toolbar?.menu == true" [ngStyle]="{'color':'black'}" (click)="viewMenu()"><mat-icon>local_dining</mat-icon><span class="menu-icon">Menu</span></button>
    </ng-template>
  </ng-template>

  <!-- BLACK BACKGROUND -->
  <ng-template [ngIf]="config === 'black'">
    <div *ngIf="viewport?.name == 'xs'; else menu_label">
      <button mat-icon-button title="Menu" *ngIf="toolbar?.menu == true" [ngStyle]="{'color':'white'}" (click)="viewMenu()"><mat-icon>local_dining</mat-icon></button>
    </div>
    <ng-template #menu_label>
      <button mat-button class="button-rounded" title="Menu" *ngIf="toolbar?.menu == true" [ngStyle]="{'color':'white'}" (click)="viewMenu()"><mat-icon>local_dining</mat-icon><span class="menu-icon">Menu</span></button>
    </ng-template>
  </ng-template>

</ng-container>


<ng-container>
<button mat-icon-button title="Cart" *ngIf="toolbar?.cart == true" (click)="orderView()">
<ng-container *ngIf="quantity > 0; else noBadge">
<mat-icon class="active-item" matBadge="{{quantity}}" matBadgeColor="accent">assignment</mat-icon>
</ng-container>
<ng-template #noBadge>
<mat-icon matBadgeColor="accent">assignment</mat-icon>
</ng-template>

</button>
</ng-container>

<!-- LANGUAGE ICON -->
<ng-container *ngIf="toolbar?.language == true">
  <ng-template [ngIf]="toolbar?.i18n == 'en'">
    <button mat-button class="button-rounded" (click)="lang_fr()" arial-label="Francais"><img src="{{language_fr}}" width='36px' height='auto'></button>
  </ng-template>
  <ng-template [ngIf]="toolbar?.i18n == 'fr'">
    <button mat-button  class="button-rounded"  (click)="lang_en()"><img src="{{language_en}}" width='36px' height='auto'></button>
  </ng-template>
</ng-container>

  <ng-content></ng-content>
</mat-toolbar>